import React from 'react'
import PropTypes from 'prop-types'
import {Modal} from "antd"

ModalConfirm.propTypes = {
    isModalVisible: PropTypes.bool.isRequired,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

function ModalConfirm(props) {
    const {isModalVisible, onOk, onCancel} = props

    return (
        <div className="ModalConfirm">
            <Modal
                className='ModalConfirm'
                title="Discard all unsaved changes"
                visible={isModalVisible}
                onOk={onOk}
                onCancel={onCancel}
            >
                <p>If you discard changes, you'll delete any edits you made since you last.</p>
            </Modal>
        </div>
    )
}

export default ModalConfirm